import { connect } from 'react-redux'
import ServiceEditPane from '../../components/services/edit/ServiceEditPane'
import { fetchService, actionCreators } from '../../state/actions/services/index'
import { IStoreState } from '../../types/index'

const mapStateToProps = (state: IStoreState, ownProps: any) => {
  return {
    serviceId: state.service.metadata.edit.serviceId,
    updatingError: state.serviceEdit.steps.currentStep.updatingError,
    fetchingError: state.serviceEdit.steps.currentStep.fetchingError,
    routeProps: ownProps,
    zones: state.goinzones.items,
    locations: state.service.locationList
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    onComponentMount: (serviceId: string) => {
      dispatch(actionCreators.serviceEditClearState())
      dispatch(fetchService(serviceId))
      dispatch(actionCreators.serviceCreateSetServiceId(serviceId))
    },
    onHideErrorClick: () => {
      dispatch(actionCreators.serviceCreateSetFetchingError(''))
      dispatch(actionCreators.serviceCreateSetUpdatingError(''))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ServiceEditPane)



// WEBPACK FOOTER //
// ./src/containers/services/ServiceEditPane.ts